// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V8Lu+","cnt":"Footer_cnt__FId4d","links":"Footer_links__fwADJ","site":"Footer_site__EXLBl"};